import * as actionTypes from "./actionTypes";

export const toggleFilter = filter => {
  return {
    type: actionTypes.UI_TOGGLE_FILTER,
    payload: { filter: filter }
  };
};
export const languageChanged = language => {
  return {
    type: actionTypes.UI_CHANGE_LANGUAGE,
    payload: { language: language }
  };
};

export const saveSelectedTags = selectedTags => {
  return {
    type: actionTypes.UI_SAVE_SELECTEDTAGS,
    payload: { selectedTags: selectedTags }
  };
};

export const saveSelectedModels = selectedModels => {
  return {
    type: actionTypes.UI_SAVE_SELECTEDMODELS,
    payload: { selectedModels: selectedModels }
  };
};

export const addApiTags = apiTags => {
  return {
    type: actionTypes.UI_ADD_APITAGS,
    payload: { apiTags: apiTags }
  };
};

export const addApiConsumption = apiConsumption => {
  return {
    type: actionTypes.UI_ADD_APICONSUMPTION,
    payload: { apiConsumption: apiConsumption }
  };
};

export const addApiModels = apiModels => {
    console.log(apiModels);
  return {
    type: actionTypes.UI_ADD_APIMODELS,
    payload: { apiModels: apiModels }
  };
};

export const addApiAppsConfig = appsConfig => {
  return {
    type: actionTypes.UI_ADD_APIAPPSCONFIG,
    payload: { appsConfig: appsConfig }
  };
};

export const addApiUploadConfig = uploadConfig => {
  return {
    type: actionTypes.UI_ADD_APIUPLOADCONFIG,
    payload: { uploadConfig: uploadConfig }
  };
};

export const addApiExpertSearchConfig = expertSearchConfig => {
  return {
    type: actionTypes.UI_ADD_APIEXPERTSEARCHCONFIG,
    payload: { expertSearchConfig: expertSearchConfig }
  };
};


export const addTempConfig = tempConfig => {
  return {
    type: actionTypes.UI_ADD_TEMPCONFIG,
    payload: { tempConfig: tempConfig }
  };
};

export const tempSaveData = tempObj => {
  return {
    type: actionTypes.UI_TEMP_SAVEDATA,
    tempObj: tempObj
  };
};

export const tempOpened = () => {
  return {
    type: actionTypes.UI_TEMP_OPENED
  };
};
export const tempClosed = () => {
  return {
    type: actionTypes.UI_TEMP_CLOSED
  };
};

export const saveWebapiFilePath = filePath => {
  return {
    type: actionTypes.UI_SAVE_WEBAPI_FILEPATH,
    payload: { webApiFilePath: filePath }
  };
};

export const postMediaWithUpload = (mediaFile, msg) => {
  window.flow
    .uploadFile(mediaFile)
    .promise.then(res => {
      window.flow
        .twitterPostImage(res.localfile, msg)
        .then(response => {
          // dispatch(postWebapiMessageSuccess(response));
          console.log("LAMTEST postMedia response", response);
        })
        .catch(response => {
          console.log(response);
        });
    })
    .catch(error => {
      console.log("LAMTEST uploadFile error");
    });
};

export const postMedia = (mediaPath, msg) => {
  window.flow
    .twitterPostMedia(mediaPath, msg)
    .then(response => {
      console.log("LAMTEST postMedia response", response);
    })
    .catch(response => {
      console.log(response);
    });
};

export const postMessage = msg => {
  window.flow
    .twitterPostTweets(msg)
    .then(response => {
      // dispatch(postWebapiMessageSuccess(response));
      console.log("LAMTEST postWebapiMessge response", response);
    })
    .catch(response => {
      console.log(response);
    });
};

export const deleteWebapiMessage = msgId => {
  return dispatch => {
    window.flow
      .twitterDeleteTweets(msgId)
      .then(response => {
        console.log("LAMTEST postWebapiMessge response", response);
      })
      .catch(response => {
        console.log(response);
      });
  };
};

export const postWebapiMessage = (mediaFile, msg) => {
  console.log("LAMTEST mediaFile", mediaFile);
  return dispatch => {
    if (mediaFile === null || mediaFile === undefined) {
      postMessage(msg);
    } else {
      postMediaWithUpload(mediaFile, msg);
    }
  };
};

export const postWebapiMedia = (mediaPath, msg) => {
  return dispatch => {
    if (mediaPath === "") {
      postMessage(msg);
    } else {
      postMedia(mediaPath, msg);
    }
  };
};

export const leftSidebarOpened = () => {
  return {
    type: actionTypes.UI_LEFT_SIDEBAR_OPENED
  };
};
export const leftSidebarClosed = () => {
  return {
    type: actionTypes.UI_LEFT_SIDEBAR_CLOSED
  };
};
export const leftSidebarOpening = () => {
  return {
    type: actionTypes.UI_LEFT_SIDEBAR_OPENING
  };
};
export const leftSidebarClosing = () => {
  return {
    type: actionTypes.UI_LEFT_SIDEBAR_CLOSING
  };
};
export const metadataOpened = () => {
  return {
    type: actionTypes.UI_METADATA_OPENED
  };
};
export const metadataClosed = () => {
  return {
    type: actionTypes.UI_METADATA_CLOSED
  };
};
export const panelOpen = () => {
  return {
    type: actionTypes.UI_PANEL_OPEN
  };
};
export const panelClose = () => {
  return {
    type: actionTypes.UI_PANEL_CLOSE
  };
};
export const setClipListViewMode = viewMode => {
  return {
    type: actionTypes.UI_SET_CLIPLIST_VIEW_MODE,
    payload: { clipListViewMode: viewMode }
  };
};

export const uploadOpened = () => {
  return {
    type: actionTypes.UI_UPLOAD_OPENED
  };
};
export const uploadClosed = () => {
  return {
    type: actionTypes.UI_UPLOAD_CLOSED
  };
};

export const uploadOpening = () => {
  return {
    type: actionTypes.UI_UPLOAD_OPENING
  };
};

export const uploadAddDragDrop = counter => {
  return {
    type: actionTypes.UI_UPLOAD_ADD_DRAGDROP,
    payload: { uploadDragDropCounter: counter }
  };
};

export const expertSearchOpened = () => {
  return {
    type: actionTypes.UI_EXPERT_SEARCH_OPENED
  };
};
export const expertSearchClosed = () => {
  return {
    type: actionTypes.UI_EXPERT_SEARCH_CLOSED
  };
};


export const expertSearchSaveData = searchedObj => {
  return {
    type: actionTypes.UI_EXPERT_SEARCH_SAVEDATA,
    searchedObj: searchedObj
  };
};

export const expertSearchSetupData = initialObj => {
  return {
    type: actionTypes.UI_EXPERT_SEARCH_SETUPDATA,
    searchedObj: initialObj
  };
};

export const selectLanguage = lang => {
  return {
    type: actionTypes.UI_SELECT_LANGUAGE,
    language: lang
  };
};

export const displayCountries = opened => {
  return {
    type: actionTypes.UI_DISPLAY_COUNTRIES,
    payload: opened
  };
};

export const selectCountries = country => {
  return {
    type: actionTypes.UI_SELECT_COUNTRIES,
    payload: country
  };
};

export const removeCountries = country => {
  return {
    type: actionTypes.UI_REMOVE_COUNTRIES,
    payload: country
  };
};

export const removeAllCountries = () => {
  return {
    type: actionTypes.UI_REMOVE_ALLCOUNTRIES
  };
};

export const setSortOrder = (sortOrder, target) => {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_SORTORDER,
      payload: {
        sortOrder: sortOrder,
        target: target,
        allClips: getState().clipList.clips
      }
    });
  };
};

export const setSidebarFilter = state => {
  return {
    type: actionTypes.SET_SIDEBAR_FILTER,
    payload: { show: state }
  };
};

// Config

const loadUiConfigStart = () => {
  return {
    type: actionTypes.LOAD_UI_CONFIG_START
  };
};

const loadUiConfigSuccess = (config) => {
  return {
    type: actionTypes.LOAD_UI_CONFIG_SUCCESS,
    config: config
  };
};

const loadUiConfigFail = (error) => {
  return {
    type: actionTypes.LOAD_UI_CONFIG_FAIL,
    error: error
  };
};

export const loadUiConfig = (local = true) => {
  return dispatch => {
    if (local) {
      console.log("LOAD LOCAL UI CONFIG");
      dispatch(loadUiConfigStart());
      import(`${process.env.REACT_APP_APPID}/config/UIConfig`).then((module) => {
        dispatch(loadUiConfigSuccess(module));
		dispatch({ type: actionTypes.CLIPLIST_SET_PLAYER_DERIVATIVES, derivatives: module.PLAYER_DERIVATIVES });
      }).catch((res) => {
        dispatch(loadUiConfigFail(res.message));
      });
    } else {
      console.log("LOAD EXTERNAL UI CONFIG");

      // TODO
      // remove and implement correct process to load config from server

      dispatch(loadUiConfigStart());
      import(`${process.env.REACT_APP_APPID}/config/UIConfig`).then((module) => {
        dispatch(loadUiConfigSuccess(module));
		dispatch({ type: actionTypes.CLIPLIST_SET_PLAYER_DERIVATIVES, derivatives: module.playerDerivatives });
      }).catch((res) => {
        dispatch(loadUiConfigFail(res.message));
      });
    }
  }
};
